import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "26",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M16.682 13.778a5.61 5.61 0 0 1 2.651-4.671 5.77 5.77 0 0 0-4.49-2.428c-1.889-.198-3.72 1.13-4.683 1.13-.981 0-2.464-1.11-4.06-1.077a6.03 6.03 0 0 0-5.032 3.069C-1.107 13.568.516 19.104 2.6 22.149c1.042 1.49 2.261 3.156 3.856 3.097 1.56-.064 2.143-.995 4.027-.995 1.866 0 2.412.995 4.04.958 1.674-.027 2.729-1.498 3.735-3.003a12.3 12.3 0 0 0 1.708-3.479 5.43 5.43 0 0 1-3.284-4.95M13.609 4.677A5.48 5.48 0 0 0 14.863.75a5.58 5.58 0 0 0-3.609 1.867A5.26 5.26 0 0 0 9.968 6.4a4.67 4.67 0 0 0 3.641-1.722"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }